import { render, staticRenderFns } from "./Convenio.vue?vue&type=template&id=3cf4e7aa"
import script from "./Convenio.vue?vue&type=script&lang=js"
export * from "./Convenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports